export function isValidJSON(jsonString) {
  try {
    JSON.parse(jsonString);
    return true;
  } catch (error) {
    // JSON parsing failed, likely due to invalid or missing data.
    return false;
  }
}
